import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'


type Props = { tabs: { title: string, path: string }[] }
const WizardTabs:React.FC<Props> = ({ tabs }) => {
  const location = useLocation()
  const activeIndex = tabs.findIndex(tab => location.pathname === tab.path)
  return (
    <div className='flex w-full justify-around sm:py-4'>
      {tabs.map((tab, index) => (
        <div key={tab.title} className='w-full'>
          <div className={`h-2 mb-3 -ms-10 ${activeIndex === index ? 'w-10 rounded-e-full' : 'w-full'} ${activeIndex >= index ? 'bg-deep-green' : 'bg-soft-green'}`}/>
          <NavLink className={({ isActive }) => isActive ? 'font-bold text-deep-green' : ''} to={tab.path}>
            <span className='hidden sm:block'>{tab.title}</span>
            <span className={`inline-block sm:hidden rounded-full w-[26px] h-[26px] pt-0.5 text-xs text-center ${activeIndex >= index ? 'bg-deep-green text-white' : 'bg-soft-green text-black'}`}>{index + 1}</span>
          </NavLink>
        </div>
      ))}
    </div>
  )
}

export default WizardTabs
